import UI from './utils/UI'
import Flickity from 'flickity-imagesloaded'

UI({
  component: '.js-carousel',
  cells: ['.js-carousel-cell']
}, ({ component, cells }) => {
  if (cells.length < 2) {
    component.style.opacity = 1
    return
  }

  /* eslint-disable no-new */
  new Flickity(component, {
    arrowShape: 'M92.857 42.403h-68.47l28.214-28.214c2.786-2.786 2.786-7.307 0-10.1-2.793-2.785-7.314-2.785-10.1 0L2.095 44.496a7.135 7.135 0 0 0 0 10.1L42.5 95.001a7.135 7.135 0 0 0 10.1 0c2.786-2.793 2.786-7.314 0-10.1L24.387 56.688h68.47c3.943 0 7.143-3.2 7.143-7.142 0-3.943-3.2-7.143-7.143-7.143',
    pageDots: false,
    wrapAround: true,
    imagesLoaded: true
  })
  /* eslint-enable no-new */
})
